<template>
  <div class="content">
    <div class="row animated fadeIn">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Perf & Security Center</h4>
            <div class="row">
              <div class="col-md-10">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item">
                    <a
                        class="nav-link active show"
                        id="active-tab"
                        data-toggle="tab"
                        href="#pending"
                        role="tab"
                        aria-controls="up"
                        @click="activeTab='pending'"
                    >Pending</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                        class="nav-link"
                        id="review-tab"
                        data-toggle="tab"
                        href="#review"
                        role="tab"
                        aria-controls="down"
                        @click="activeTab='review'"
                    >Review</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                        class="nav-link"
                        id="review-tab"
                        data-toggle="tab"
                        href="#customerReview"
                        role="tab"
                        aria-controls="down"
                        @click="activeTab='customerReview'"
                    >Customer Review</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                        class="nav-link"
                        id="resolved-tab"
                        data-toggle="tab"
                        href="#resolved"
                        role="tab"
                        aria-controls="down"
                        @click="activeTab='resolved'"
                    >Finished</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                        class="nav-link"
                        id="abandoned-tab"
                        data-toggle="tab"
                        href="#abandoned"
                        role="tab"
                        aria-controls="down"
                        @click="activeTab='abandoned'"
                    >Abandoned</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                        class="nav-link"
                        id="abandoned-tab"
                        data-toggle="tab"
                        href="#idList"
                        role="tab"
                        aria-controls="down"
                        @click="activeTab='idList'"
                    >Collected IDs List</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                        class="nav-link"
                        data-toggle="tab"
                        href="#performance-audit-report"
                        role="tab"
                        aria-controls="down"
                        @click="activeTab='performanceAuditReport'"
                    >Performance Audit Report</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="card-body" style="padding-top: 0 !important">
            <div class="tab-content customer-table">
              <div id="pending" class="tab-pane active show">
                <div v-if="activeTab === 'pending'">
                <CFTasksList
                    ref="pendingTasks"
                    type="pending"
                />
                </div>
              </div>
              <div id="review" class="tab-pane fade"  >
                <div v-if="activeTab === 'review'">
                <CFTasksList
                    ref="reviewTasks"
                    type="review"
                />
               </div>
              </div>
              <div id="customerReview" class="tab-pane fade"  >
                <div v-if="activeTab === 'customerReview'">
                  <CFTasksList
                      ref="reviewTasks"
                      type="customerReview"
                  />
                </div>
              </div>
              <div id="resolved" class="tab-pane fade" >
                <div v-if=" activeTab === 'resolved'">
                  <CFTasksList ref="finishedMigrations" type="finished" />
                </div>
              </div>
              <div id="abandoned" class="tab-pane fade"  >
                <div v-if="activeTab === 'abandoned'">
                  <CFTasksList type="abandoned" />
                </div>

              </div>
              <div id="idList" class="tab-pane fade" >
                <div v-if="activeTab === 'idList' ">
                  <IDsList />
                </div>
              </div>
              <div id="performance-audit-report" class="tab-pane fade" >
                <div v-if="activeTab === 'performanceAuditReport' ">
                  <PerformanceAuditReport />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <custom-status-modal ref="customStatus" />
    <ticket-custom-message ref="ticketMessage" :presetMacros="presetMacros" />
    <collectIDsModal ref="idsModal" />

  </div>
</template>
<script>
import CFTasksList from "@/components/Admin/CloudflareEnt/CFTasksList.vue";

export default {
  name: "cfEntTasks",
  computed: {
    CFTasksList() {
      return CFTasksList
    }
  },
  components: {
    CFTasksList: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/CloudflareEnt/CFTasksList.vue"
            ),
    IDsList: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/CloudflareEnt/IDsList.vue"
            ),
    CustomStatusModal: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/CloudflareEnt/CustomStatusModal.vue"
            ),
    ticketCustomMessage: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/CloudflareEnt/ticketCustomMessage.vue"
            ),
    collectIDsModal: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/CloudflareEnt/collectIDsModal.vue"
            ),
    PerformanceAuditReport: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/CloudflareEnt/PerformanceAuditReport.vue"
            ),
  },
  data () {
    return {
      activeTab: "pending",
      presetMacros: []
    }
  }
}
</script>

<style scoped>
.nav-tabs .nav-item .nav-link.active:before,
.nav-tabs .nav-item .nav-link.active:hover:before,
.nav-tabs .nav-item .nav-link.active:focus:before {
  border: 0;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}

.nav-tabs .nav-link {
  border: 1px solid transparent !important;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff !important;
}

.nav-tabs .nav-item .nav-link.active {
  color: #5b7cfb;
}
</style>
